import { Layout, Menu } from 'antd';
import { AppstoreOutlined, SettingOutlined, UploadOutlined, FileTextOutlined, ApiOutlined, BookOutlined, LockOutlined, ThunderboltOutlined, PieChartOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const { Sider } = Layout;

export function AppSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { role } = useAuth();

  const apiGuideChildren = [
    {
      key: '/api-guide',
      icon: <BookOutlined />,
      label: 'User API',
    },
    ...(role === 'admin' ? [
      {
        key: '/api-guide/admin',
        icon: <LockOutlined />,
        label: 'Admin API',
      },
    ] : []),
  ];

  const menuItems = [
    {
      key: '/products',
      icon: <AppstoreOutlined />,
      label: 'Products',
    },
    ...(role === 'admin' ? [
      {
        key: '/import',
        icon: <UploadOutlined />,
        label: 'Import',
      },
      {
        key: '/preseed',
        icon: <ThunderboltOutlined />,
        label: 'Pre-seed',
      },
      {
        key: '/logs',
        icon: <FileTextOutlined />,
        label: 'API Logs',
      },
      {
        key: '/coverage',
        icon: <PieChartOutlined />,
        label: 'Coverage',
      },
      {
        key: '/settings',
        icon: <SettingOutlined />,
        label: 'Settings',
      },
    ] : []),
    {
      key: 'api-guide-group',
      icon: <ApiOutlined />,
      label: 'API Guide',
      children: apiGuideChildren,
    },
  ];

  // Open the API Guide submenu if we're on an api-guide page
  const openKeys = location.pathname.startsWith('/api-guide') ? ['api-guide-group'] : [];

  return (
    <Sider
      width={220}
      style={{
        borderRight: '1px solid rgba(0, 0, 0, 0.06)',
      }}
    >
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        defaultOpenKeys={openKeys}
        items={menuItems}
        onClick={({ key }) => {
          if (key !== 'api-guide-group') navigate(key);
        }}
        style={{ height: '100%', borderRight: 0 }}
      />
    </Sider>
  );
}
